export default "__VITE_ASSET__CRGz6LT3__"